import { useContext } from 'react';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

import { SelectedMarkerIconCommon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerIconCommon';
import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';

interface Props {
    markerId: string;
}

export const SelectedMarkerV2Icon = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    const iconMarkers = ctxEdit.worldMarkers.filter(
        (e): e is IIconV2WorldMarker => e.elementType === 'v2/icon'
    );

    return (
        <SelectedMarkerIconCommon
            markerId={props.markerId}
            type={'v2/icon'}
            allMarkersOfType={iconMarkers}
        />
    );
};
